import { Pipe, PipeTransform } from "@angular/core";
import { PartecipantRoles } from "../models/WebServer/partecipantRoles";
import { PartecipantStatus } from "../models/WebServer/partecipantStatus";
import { AppConfigService } from "../services/app.config.service";

@Pipe({
  name: 'closeCurrentCall',
})
export class CloseCurrentCallPipe implements PipeTransform {
  constructor(private config: AppConfigService/*, private isOnCall: IsOnCallPipe*/) { }
  public transform(partecipantId: string | PartecipantStatus | undefined, participants: PartecipantStatus[] | undefined = undefined): boolean {
    // console.log(`********** IsOnCallPipe ${phoneStatus} => early ${early}`)
    participants = participants ?? this.config.getPartecipantsStatus();

    const part = participants.find( z => z.partecipantId == partecipantId);
    
    // Non mostrare per se stessi o per operatori
    if(!part || part.partecipantId == this.config.partecipantId || part.partecipantRole == PartecipantRoles.PrimaryClient) return false; 

    return this.config.onCallPipe.transform(part.phoneStatus);
  }
}
